// Copyright (c) 2021 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import massLaborRateRequestStatusDetails from './mass-labor-rate-request-status-details';
import requestFiltered from './requests-filtered';
import searchFilters from './search-filters';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    massLaborRateRequestStatusDetails,
    requestFiltered,
    searchFilters
});



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/reducers/index.js